import { Slider } from 'antd';
import { useMemo, useRef, useState } from 'react';
import Price from '../Price';

const PriceSelect = (props: {
  values: string[];
  filterStateRewrite: string;
  onAfterChange: (min: number, max: number) => void;
}) => {
  const { values, filterStateRewrite, onAfterChange } = props;

  const [min, max] = useMemo(() => {
    const numbers = values.reduce<number[]>((acc, cur) => {
      for (const numberPart of cur.split('_')) {
        if (!numberPart) {
          acc.push(0);
          continue;
        }

        const numericPart = parseInt(numberPart);

        if (!isNaN(numericPart)) {
          acc.push(numericPart);
        }
      }

      return acc;
    }, []);

    return [Math.min(...numbers), Math.max(...numbers)];
  }, [values]);

  const [currentMin, setCurrentMin] = useState<number | null>(() => {
    return filterStateRewrite ? parseInt(filterStateRewrite.split('_')[0]) || null : null;
  });
  const [currentMax, setCurrentMax] = useState<number | null>(() => {
    return filterStateRewrite ? parseInt(filterStateRewrite.split('_')[1]) || null : null;
  });
  const prevPropsRef = useRef({ filterStateRewrite });

  if (prevPropsRef.current.filterStateRewrite !== filterStateRewrite) {
    prevPropsRef.current.filterStateRewrite = filterStateRewrite;

    if (filterStateRewrite) {
      const [min, max] = filterStateRewrite.split('_');

      setCurrentMin(parseInt(min, 10));
      setCurrentMax(parseInt(max, 10));
    } else {
      setCurrentMin(null);
      setCurrentMax(null);
    }
  }

  return (
    <div className='[&_.ant-slider-handle]_after_!shadow-[0_0_0_2px_#80583f] [&_.ant-slider-track]_!bg-80583F'>
      <div className='flex items-center justify-between'>
        <span className='inline-block py-[5px] text-[13px]'>
          <Price
            value={currentMin || min}
            currencyCode={process.env.NEXT_PUBLIC_DEFAULT_DISPLAY_CURRENCY_CODE}
            showFractionDigits={false}
          />
        </span>
        <span className='inline-block py-[5px] text-[13px]'>
          <Price
            value={currentMax || max}
            currencyCode={process.env.NEXT_PUBLIC_DEFAULT_DISPLAY_CURRENCY_CODE}
            showFractionDigits={false}
          />
        </span>
      </div>
      <div className='px-[5px]'>
        <Slider
          range
          step={1}
          min={min}
          max={max}
          value={[currentMin === null ? min : currentMin, currentMax === null ? max : currentMax]}
          onChange={value => {
            setCurrentMin(value[0]);
            setCurrentMax(value[1]);
          }}
          onAfterChange={value => {
            onAfterChange(value[0], value[1]);
          }}
          tooltip={{
            open: false,
          }}
        />
      </div>
    </div>
  );
};

export default PriceSelect;
